/*
* @TagTable.vue
* @Description 基站管理组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">
            <!--查询工具条-->
            <el-col style="padding: 0;">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item class="fixed-item-box" style="position: absolute;top: 9px;right: 10px;margin: 0;z-index: 3;">
                        <el-button  type="primary" trigger="click" @click="addGroup"><i class="el-icon-circle-plus-outline" /> 新增测距基站组</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <!-- 表格 -->
            <el-table :data="tableInfos"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      style="width: 100%;margin-bottom: 10px;height: calc(100% - 44px);"
                      @row-click="rowHandle"
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column label="测距组id" width="100">
                    <template v-slot="scope">
                      {{scope.row.groupId}} <i class="el-icon-warning" title="测距组的基站缺失" v-if="scope.row.bsSpacingStatus==1"></i>
                    </template>
                </el-table-column>
                <el-table-column label="测距基站">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bs.join(', ')">{{scope.row.bs.join(", ")}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="测距数量">
                    <template v-slot="scope">
                        {{scope.row.rangeNum}}
                    </template>
                </el-table-column>
                <el-table-column label="基站状态">
                  <template v-slot="scope">
                    {{scope.row.bsSpacingStatus==1?'基站缺失':'正常测距'}}
                  </template>
                </el-table-column>
                <el-table-column label="测距状态">
                    <template v-slot="scope">
                        {{scope.row.status==1?'正在测距中':'可以测距'}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template v-slot="scope">
                        <el-button-group>
                            <span  class="el-icon-s-unfold" size="mini" @click="()=>{preStart(scope.row, scope.$index)}" trigger="click"  title="测距明细">测距明细</span>
                            <span  class="el-icon-delete" size="mini" @click="()=>{deleteRow(scope.row, scope.$index)}" trigger="click" title="删除">删除</span>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

            <!-- 新增基站 -->
            <UwbBSRangeAddDialog ref="uwbBSRangeAddDialog" @research="research"/>

            <!-- 基站测距 -->
            <UwbBSRangeDialog ref="uwbBSRangeDialog" :rangeGroup="rangeGroup" @research="research"/>

        </section>
    </div>

</template>

<script>
    // 基站组件
    import ApiOam from '@/request/api-oam'
    // 分页组件
    import Pagination from '@/components/Pagination.vue'
    // 基站组改弹出层
    import UwbBSRangeAddDialog from "./UwbBSRangeAddDialog";
    import UwbBSRangeDialog from "./UwbBSRangeDialog";

    export default {
        name: "UwbBSSelfRangeTable",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        components: {
            // 分页工具
            Pagination,
            UwbBSRangeAddDialog,
            UwbBSRangeDialog
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        data() {
            return {
                /**
                 * @Des 查询条件属性
                 * @Auth jsh
                 * @Date 09:41 2021/6/28
                 */
                filters: {
                    projectId: this.$store.state.currentProjectId,
                    orderBy: {
                        "project_id": "asc",
                        "group_id": "asc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom',
                },
                tableInfos:[],
                rangeGroup: {},
                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 50,
                    currentPage: 1
                },
            }
        },
        computed: {
        },
        created(){
            // 查询登录账户的项目
            this.searchRangeBsGroup();
        },
        mounted(){
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 09:42 2021/6/28
         */
        methods: {

            /**
             * @Author ZhangBin
             * @Description //TODO 重新搜索
             * @Date 17:25 2022/5/18
             * @Param
             * @return
             **/
            research(){
               this.pagination.total = 0;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
                this.searchRangeBsGroup();
            },

            /**
             * @Des 查询基站组
             * @Auth jsh
             * @Date 09:42 2021/6/28
             */
            searchRangeBsGroup() {
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Range_Bs_Uri, {
                    projectId: this.filters.projectId,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    // console.log(result)
                    this.tableInfos = [];
                    this.pagination.total = result.total;
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            row.bs = [];
                            row.bsSelfRanges.forEach((r, i)=>{
                                row.bs.push(r.bsSid);
                            })
                            if(this.rangeGroup && this.rangeGroup.index == index){
                                row.bsGroups = this.rangeGroup.bsGroups;
                                row.index = index;
                                this.rangeGroup = Object.assign({}, row);
                                this.$refs.uwbBSRangeDialog.flushTable();
                            }
                            this.tableInfos.push(row);
                        })
                    }
                }).catch(error => {
                    console.error('查询测距基站组异常', ApiOam.Search_Uwb_Range_Bs_Uri, error);
                })
            },

            /**
             * 是否选择
             * */
            checkSelectable(row){
                return true;
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order == null){
                    this.filters.orderBy["project_id"] = "asc";
                }else{
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.research();
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
                this.searchRangeBsGroup();
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
                this.searchRangeBsGroup();
            },

            /**
             * 删除行
             * @param row
             */
            deleteRow(row){
                this.$confirm(
                    '确认删除测距基站组吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    let param = {
                        groupId: row.groupId
                    };
                    this.delete(param);
                });
            },
            delete(param){
                if(this.locked) return;
                this.locked = true;
                this.$request.postJsonRequest(ApiOam.Delete_Uwb_Range_Group_Uri, param).then(result => {
                    // console.log(result);
                    if(result.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.locked = false;
                    this.research();
                }).catch(error => {
                	this.locked = false;
                	console.error('删除测距基站组异常', ApiOam.Delete_Uwb_Range_Group_Uri, error);
                })
            },
            /**
             * 处理行
             * @param row
             */
            rowHandle(row){
                if(row.checked){
                    row.checked = false;
                }else{
                    row.checked = true;
                }
                this.$refs.multipleTable.toggleRowSelection(row, row.checked)
            },
            /**
             * 新增基站组
             */
            addGroup(){
                this.$refs.uwbBSRangeAddDialog.openDialog("添加测距基站", "确定添加");
            },
            /**
             * @Author ZhangBin
             * @Description //TODO 准备测距
             * @Date 17:58 2022/5/18
             * @Param
             * @return
             **/
            preStart(row, index){
                this.searchBsGroup(row, index);
            },
            /**
             * @Des 查询基站组
             * @Auth jsh
             * @Date 09:42 2021/6/28
             */
            searchBsGroup(row, index) {
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Group_Uri, {
                    projectId: row.projectId,
                    orderBy: {"group_id": "asc"},
                    total: 0,
                    startNum: 0,
                    limit: 0,
                }).then(result => {
                    // console.log(result)
                    let bsGroups = {};
                    if(result.total > 0){
                        result.rows.forEach((r, i)=>{
                            bsGroups[r.groupId] = r;
                        })
                    }
                    row.index = index;
                    row.bsGroups = bsGroups;
                    this.rangeGroup = row;
                    this.$refs.uwbBSRangeDialog.openDialog("自动测距", "开始测距");
                }).catch(error => {
                    console.error('查询基站组异常', ApiOam.Search_Uwb_Bs_Group_Uri, error);
                })
            },

        },


    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSSelfRangeTable.vue